import { writable } from "svelte/store";

const messageStore = writable("");
let messages = "";

let status;

let socket; // = new WebSocket('wss://onlineju.herokuapp.com/api/v2/runcode/');

let timer;
let s = 0;

const close = () => {
  messages = "";    
  socket && socket.close();
}

const sendChar = (char) => {
    messages += char;
    messageStore.set(messages);    
}

const sendMessage = (message) => {
  if (socket && socket.readyState == 1) {
    socket.send(message);
    messages += JSON.parse(message).startClass + "\n";
    messageStore.set(messages);
  }
};

const runCode = (message) => {
  if (socket) {
    if (socket.readyState <= 1) {
      socket.send(message);
    } else {
      socket = null;
    }
  } else {
    try {
      socket = new WebSocket("wss://onlineju.herokuapp.com/api/v2/runcode/");
      // messages = "Запуск программы...\n\n";
      messages = "Запуск программы";
      messageStore.set(messages);
      let checkCodeButton = document.getElementById('check-code-button');
      checkCodeButton.style.display = 'none';
      timer = setInterval(() => {
        messages += ".";
        messageStore.set(messages);
      }, 300);      
    } catch (e) {
      clearTimeout(timer); 
      messages += "\n\n(Программа не запущена. Сервер не доступен)\n";
      messageStore.set(messages);
    }

    socket.onopen = () => {
      console.log("It's open");  
      clearTimeout(timer);
      // let runCodeSendToConsoleButtonTimer = setTimeout(() => {
      let runCodeSendToConsoleButton = document.getElementById('runCodeSendToConsoleButton');
      runCodeSendToConsoleButton.style.display = 'block';
      // }, 500);
      messages = "";
      socket.send(message);
      // console.log(JSON.stringify(startMessage));
      // socket.send(JSON.stringify(startMessage));
      // setTimeout(() => clearTimeout(timer), 4000);
    };

    socket.onmessage = (msg) => {
      // console.log("md msg.data.status: " + msg.data.status);
      let json = JSON.parse(msg.data);
      // messages += msg.data;// + "\n";
      messages += json.message;
      status = json.status;
      messageStore.set(messages);
      var textarea = document.getElementById('runCodeOutput');
      if (textarea) textarea.scrollTop = textarea.scrollHeight;
    //   messageStore.set(msg.data);
      console.log("md: " + JSON.stringify(json, null, 2));
      console.log("md status: " + JSON.stringify(json.status, null, 2));
      // console.log("md: " + JSON.parse(msg.data).userMessage);
      // console.log("md: " + msg.data.userMessage);
    };

    socket.onclose = () => {
      console.log("WebSocket connection closed");
      clearTimeout(timer);
      let runCodeSendToConsoleButton = document.getElementById('runCodeSendToConsoleButton');
      if (runCodeSendToConsoleButton) runCodeSendToConsoleButton.style.display = 'none';
      let checkCodeButton = document.getElementById('check-code-button');
      if (checkCodeButton) checkCodeButton.style.display = 'block';
      switch (status) {
        case "OK":
          messages += "\n\n(Выполнение программы завершено)\n";
          break;
        case "COMPILE_ERROR":
          messages += "\n\n(Программа не может быть запущена, в ней ошибка)\n";
          break;
        case "SERVER_ERROR":
          messages += "\n\n(Ошибка на стороне сервера)\n";
          break;
        default:
          messages += "\n\n(Сервер не доступен)\n";
      }
      messageStore.set(messages);
      setTimeout(() => {
        var textarea = document.getElementById('runCodeOutput');
        if (textarea) textarea.scrollTop = textarea.scrollHeight;      
      }, 300);
      clearInterval(timer);
      socket = null;
    };
  }
};

export default {
  subscribe: messageStore.subscribe,
  sendMessage,
  runCode,
  sendChar,
  close
};